export { default } from './Number';
